/*=========================================================================================
  File Name: moduleTodoList.js
  Description: TodoList Module
==========================================================================================*/

import state from "./moduleTodoListState.js";
import mutations from "./moduleTodoListMutations.js";
import actions from "./moduleTodoListActions.js";
import getters from "./moduleTodoListGetters.js";

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
